import { AxiosError } from 'axios';
import { triggerSnackbar } from '../provider/SnackbarProvider';

export const technicalGlitchToast = () =>
  triggerSnackbar({
    message:
      'Ops! We encountered a technical glitch, Please try submitting your request shortly. Sorry for the inconvenience!',
    severity: 'error',
  });

export const networkErrorToast = () =>
  triggerSnackbar({
    message: 'Network Error! Please check internet connection and try again',
    severity: 'error',
  });

export const invalidLinkToast = () =>
  triggerSnackbar({
    message: 'Invalid link!, Your verification link is expired or Invalid',
    severity: 'error',
  });

export function handleErrorResponse<
  T extends {
    errors: string[];
    message: string;
  },
>(error: unknown, context: string, callback?: (data: T) => void) {
  if (error instanceof AxiosError) {
    const axiosError = error as AxiosError<T>;
    const response = axiosError.response;

    if (response) {
      if (response.status === 500) {
        return technicalGlitchToast();
      }

      if (response.data) {
        const data = response.data;

        const errors = data?.errors || [];

        if (errors?.length) {
          triggerSnackbar({
            message: errors[0] || 'Something went wrong',
            severity: 'error',
          });
        } else {
          triggerSnackbar({ message: data?.message, severity: 'error' });
        }

        if (callback) callback(data);

        return;
      }
    }

    if (axiosError.message === 'Network Error') {
      return networkErrorToast();
    }

    return technicalGlitchToast();
  } else {
    technicalGlitchToast();
  }
}
